import { createSelector } from 'reselect'

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

export const getStatusId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].statusId
}

export const getCardId = (state, props) => props.cardContext.id

export const getSubCards = (state, props) => {
  return state['view-card'].subCards[props.cardContext.id]
}

export const subCardIdsSelector = createSelector(
  [getSubCards],
  (subCards) =>
    Object.keys(subCards).map(key => subCards[key].cardId)
)

export default createSelector(
  [
    getBoardId,
    getStatusId,
    getCardId,
    subCardIdsSelector
  ],
  (
    boardId,
    statusId,
    cardId,
    subCardIds
  ) => ({
    boardId,
    statusId,
    cardId,
    subCardIds
  })
)
